import React from "react";
import { Link } from "react-router-dom";
import dhakaMetronic from "../../../img/Dhaka-metro.png";
import hungryMonster from "../../../img/hungry-monster.PNG";
import homeService from "../../../img/home-service.PNG";
import Fade from "react-reveal/Fade";
import github from "../../../Icon/github.png";
import live from "../../../Icon/live.png";
import "./Work.css";
import { motion } from "framer-motion";

const Work = () => {
  return (
    <div className="container mt-5 pt-5">
      <h2 className="text-center" style={{ color: '#46475c'}}><b>My Work</b></h2>
      <div className="row w-100 mt-5 pt-5">
        <div className="col-md-7 mb-5 pb-5">
          <Fade left>
            <h3 className="mb-4">
              <b>Dhaka Metro</b>
            </h3>
            <h6>
              A fully interactive web application built with React. Some of it's
              key features are ticket buy service. User authentication systems{" "}
            </h6>
            <div className="mb-4 mt-4">
              <span className="tech">React.js</span>
              <span className="tech">Firebase</span>
              <span className="tech">HTML5</span>
              <span className="tech">Bootstrap</span>
              <span className="tech">Route</span>
            </div>
            <Fade left>
              <a
                className="icon mr-2"
                href="https://github.com/sunnysakib/dhaka-metro"
              >
                <img src={github} alt="" />
              </a>
              <a
                className="icon text-cente"
                href="https://dhaka-metro-tickets.web.app/"
              >
                <img src={live} alt="" />
              </a>
            </Fade>
          </Fade>
        </div>
        <Fade right>
          <div className="col-md-5">
            <a  href="https://dhaka-metro-tickets.web.app/">
              <motion.img
                whileHover={{ scale: 1.1 }}
                className="img-fluid rounded mx-auto d-block"
                src={dhakaMetronic}
                alt=""
              ></motion.img>
            </a>
          </div>
        </Fade>
      </div>
      
      <div className="row w-100 mt-5 pt-5 mb-5 pb-5">
        <Fade left>
          <div className="col-md-5">
            <motion.img
              whileHover={{ scale: 1.1 }} 
              className="img-fluid rounded mx-auto d-block"
              src={hungryMonster}
              alt=""
            />
          </div>
        </Fade>
        <div className="col-md-7">
          <Fade right>
            <h3>
              <b>Hungry Monster</b>
            </h3>
            <h6>
              A fully interactive website built with HTML, Bootstrap and
              javaSctipt. user can search any kind of food recipe.
            </h6>
            <div className="mb-4 mt-4">
              <span className="tech">React.js</span>
              <span className="tech">Firebase</span>
              <span className="tech">HTML5</span>
              <span className="tech">Bootstrap</span>
              <span className="tech">Route</span>
            </div>
            <Fade>
              <a
                className="icon mr-2"
                href="https://github.com/sunnysakib/hungry-monster"
              >
                <img src={github} alt="" />
              </a>
              <a className="icon" href="https://sunnysakib.github.io/hungry-monster/index.html">
                <img src={live} alt="" />
              </a>
            </Fade>
          </Fade>
        </div>
      </div>
      
      <div className="row w-100 mt-5 pt-5">
        <div className="col-md-7 ">
          <Fade left>
            <h3>
              <b>Home Service</b>
            </h3>
            <h6>
              A fully interactive and responsive web application built with MERN
              stack technologies. Some of it's key features are ordering
              service, adding service, dashboard. It has admin and user role.
            </h6>
            <div className="mb-4 mt-4 tech-icon">
              <span className="tech">React.js</span>
              <span className="tech">Node.js</span>
              <span className="tech">Express.js</span>
              <span className="tech">MongoDB</span><br/>
              <span className="tech mt-3">Firebase</span>
              <span className="tech mt-3">HTML5</span>
              <span className="tech mt-3">Bootstrap</span>
              <span className="tech mt-3">Route</span>
            </div>
            <Fade left>
              <a
                className="icon mr-2"
                href="https://github.com/sunnysakib/home-service-client"
              >
                <img src={github} alt="" />
              </a>
              <a className="icon" href="https://homesrvice-bd.web.app/">
                <img src={live} alt="" />
              </a>
            </Fade>
          </Fade>
        </div>
        <Fade right>
          <div className="col-md-5 text-center">
            <a>
              <motion.img
                whileHover={{ scale: 1.1 }} 
                className="img-fluid rounded mx-auto d-block"
                src={homeService}
                alt=""
              />
            </a>
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default Work;
